import React from 'react';

// A demo store screenshot (Hero.js heroTemplates): the browser picks the smallest WebP copy that is sharp at the
// size the screenshot is shown (sizes), and browsers without WebP load the .jpg. Every other attribute goes on the <img>.
export default function PreviewImage({ template, sizes, ...img }) {
  return (
    <picture>
      <source type="image/webp" srcSet={template.previewSet} sizes={sizes} />
      <img src={template.preview} {...img} />
    </picture>
  );
}
